module.exports = __webpack_public_path__ + "img/icon-footer-informieren.d0fe6cda.svg";